// App.js
import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PortalPage from './pages/PortalPage';
import ProfilePage from './pages/portal/ProfilePage';
import SettingsPage from './pages/portal/SettingsPage';
import JoinCompanyPage from './pages/portal/JoinCompanyPage';
import ProtectedRoute from './components/ProtectedRoute';
import SuperOnlyRoute from './components/SuperOnlyRoute';
import MainLayout from './layouts/MainLayout';
import ModulePage from './pages/common/ModulePage';

// 监控中心
import StationMonitor from './pages/monitor/StationMonitor';
import VideoMonitor from './pages/monitor/VideoMonitor';
// 报警中心
import AlarmCenter from './pages/alarm/AlarmCenter';
import BatteryWarning from './pages/alarm/BatteryWarning';
import BatteryWarningDetail from './pages/alarm/BatteryWarningDetail';
import ReportCenter from './pages/analysis/ReportCenter';
import HealthAnalysis from './pages/analysis/HealthAnalysis';
import HealthAssetDetail from './pages/analysis/HealthAssetDetail';
// 展示中心
import SiteMap from './pages/display/SiteMap';
import ThreeDim from './pages/display/ThreeDim';
// 运维中心（独立页面组件：真实 CRUD / 详情弹层）
import WorkOrderPage from './pages/om/WorkOrderPage';
import PlanPage from './pages/om/PlanPage';
import GraphPage from './pages/om/GraphPage';
// 运营中心（doc01 2.19）：响应管理（独立页面组件）
import ResponsePage from './pages/biz/ResponsePage';
// 后台 · 管理中心（doc01 3.1 ~ 3.6）：独立页面组件（真实增删改）
import StationManage from './pages/admin/StationManage';
import MemberManage from './pages/admin/MemberManage';
import RoleManage from './pages/admin/RoleManage';
import CompanyManage from './pages/admin/CompanyManage';
import ThemeConfig from './pages/admin/ThemeConfig';
// 后台 · 客户中心（doc01 3.7 / 3.8）：独立页面组件（真实增删改）
import CustomerAccountPage from './pages/customer/CustomerAccountPage';
import CustomerAssetPage from './pages/customer/CustomerAssetPage';

function App() {
  // 依据手册 p24：退出登录需同步退出浏览器中所有云平台标签页的登录状态
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'logoutAt' && e.newValue) window.location.replace('/');
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/join-company" element={<JoinCompanyPage />} />
      {/* 缺陷161：邀请链接落地页，管理员生成的 /referral/<邀请码> 直接进入受邀注册流程 */}
      <Route path="/referral/:code" element={<JoinCompanyPage />} />
      <Route
        path="/portal"
        element={
          <ProtectedRoute>
            <PortalPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/portal/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/portal/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="display/multi" replace />} />

        {/* 展示中心 */}
        <Route path="display/map" element={<SiteMap />} />
        <Route path="display/3d" element={<SuperOnlyRoute><ThreeDim /></SuperOnlyRoute>} />

        {/* 监控中心 */}
        <Route path="monitor/station" element={<StationMonitor />} />
        <Route path="monitor/video" element={<VideoMonitor />} />

        {/* 报警中心 */}
        <Route path="alarm/fault" element={<AlarmCenter />} />
        <Route path="alarm/battery" element={<BatteryWarning />} />
        <Route path="alarm/battery/:id" element={<BatteryWarningDetail />} />

        {/* 分析中心 */}
        <Route path="analysis/report" element={<ReportCenter />} />
        <Route path="analysis/health" element={<HealthAnalysis />} />
        <Route path="analysis/health/:id" element={<HealthAssetDetail />} />

        {/* 运维中心（doc01 2.15 ~ 2.17）：独立页面组件 */}
        <Route path="om/workorder" element={<WorkOrderPage />} />
        <Route path="om/plan" element={<PlanPage />} />
        <Route path="om/graph" element={<GraphPage />} />

        {/* 运营中心（doc01 2.19）：响应管理（独立页面组件） */}
        <Route path="biz/response" element={<ResponsePage />} />
        {/* 核算管理：增值功能，仅超级管理员 */}
        <Route path="biz/settle" element={<SuperOnlyRoute><ModulePage /></SuperOnlyRoute>} />

        {/* 后台 · 管理中心（doc01 3.1 ~ 3.6）：独立页面组件 */}
        <Route path="admin/station" element={<StationManage />} />
        <Route path="admin/member" element={<MemberManage />} />
        <Route path="admin/role" element={<RoleManage />} />
        <Route path="admin/company" element={<CompanyManage />} />
        <Route path="admin/theme" element={<ThemeConfig />} />

        {/* 后台 · 客户中心（doc01 3.7 / 3.8）：独立页面组件 */}
        <Route path="customer/account" element={<CustomerAccountPage />} />
        <Route path="customer/asset" element={<CustomerAssetPage />} />

        {/* 其余模块由统一骨架页按信息架构配置渲染 */}
        <Route path="*" element={<ModulePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;